/**
 * Achievement definitions (visual metadata only - unlock logic is server-side).
 * Do NOT show locked achievements to other users.
 */
export const ACHIEVEMENT_META = {
  orakel: { name: "Oraklet", icon: "🔮", color: "#A78BFA" },
  headliner_hunter: { name: "Headliner Hunter", icon: "👑", color: "#F59E0B" },
  dead_eye: { name: "Dead Eye", icon: "🎯", color: "#EF4444" },
  globetrotter: { name: "Globetrotter", icon: "🌍", color: "#60A5FA" },
  danmarkskender: { name: "Danmarkskender", icon: "🇩🇰", color: "#F87171" },
  wildcard: { name: "Wild Card", icon: "🧨", color: "#FB923C" },
  on_fire: { name: "On Fire", icon: "🔥", color: "#F97316" },
  festival_boss: { name: "Festival Boss", icon: "👑", color: "#FBBF24" },
  the_manager: { name: "The Manager", icon: "🏆", color: "#FCD34D" },
  bold_but_wrong: { name: "Bold But Wrong", icon: "💀", color: "#71717A" },
};
